export let  localLang = JSON.parse(localStorage.getItem('lang')) ? JSON.parse(localStorage.getItem('lang')) : 'en'